import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  PATH_EXTERNAL_ORGANIZATIONS,
  PATH_EXTERNAL_ORGANIZATIONS_SEARCH,
  PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { OrganizationSearchPanel } from './OrganizationSearchPanel';

export const OrganizationSearchPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ExternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Recherche d'entreprises")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'tiers',
            key: 'externalThirdParties',
          },
          {
            to: PATH_EXTERNAL_ORGANIZATIONS,
            label: 'organisations',
            key: 'externalOrganizations',
          },
          {
            to: PATH_EXTERNAL_ORGANIZATIONS_SEARCH,
            label: 'recherche',
            key: 'organizationSearch',
          },
        ]}
      />
      <PageTitle title="Recherche d'entreprises" />

      <OrganizationSearchPanel />
    </>
  );
};
